var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-button"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"button-icon"},[_c('img',{attrs:{"src":_vm.content.icon}})]),_c('div',{staticClass:"button-title"},[_vm._v(_vm._s(_vm.content.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }